import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PartnerPayloadDialogData } from 'src/app/components/aftale/models';

@Component({
    selector: 'app-partner-payload',
    templateUrl: './partner-payload.component.html',
    styleUrls: ['./partner-payload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShowPartnerPayloadComponent implements OnInit {
  payload: string;
  receivedDate: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: PartnerPayloadDialogData) {}

  ngOnInit(): void {
    this.payload = this.data.payload;
    this.receivedDate = this.data.receivedDate;
  }
}
